module.exports = __webpack_public_path__ + "static/media/gearbox.d7539c76.jpg";